module.exports = __webpack_public_path__ + "img/flow1.68c89906.png";